import { HttpErrorResponse } from '@angular/common/http';
import { TimeoutError } from 'rxjs';
import { IApiOptions } from 'src/app/core/contracts/core.types';
import { BaseError } from 'src/app/core/contracts/errors/base.error';

export class HttpError extends BaseError {
  public stacktrace: unknown;
  public override name: string;
  constructor(public override message: string, public options: IApiOptions, public response: HttpErrorResponse | TimeoutError) {
    super(message);
    this.name = 'HttpError'; // this.constructor.name is useless after minification
  }
}
